import { ImagingOpenParams, PacsStudyData as PacsStudyDataNg1 } from 'estensa-module';
import { DeepPartial, DeepPascalCase } from '../../utils/types';
import moment from 'moment';
import { ModelKeyImage, ModelKeyImageInstanceInfo, OpenImagesOptions, PacsTuple } from './ebit-viewer-api';

export interface PacsStudyDataVnext {
    patient: {
        patientId?: string;
        fullName?: string;
        sex?: string;
        birthDate?: string;
    };
    study: {
        studyInstanceUID?: string;
        studyDate?: string;
        accessionNumber?: string;
        modality?: string;
    };
}

export function convertPacsTupleDatesFromISO(tuple: PacsTuple): PacsTuple {
    return {
        ...tuple,
        patientBirthDate: moment(tuple.patientBirthDate).format('YYYYMMDD'),
        studyDate: moment(tuple.studyDate).format('YYYYMMDD'),
    };
}

export function convertPacsTupleDatesFromExtensa(tuple: PacsTuple): PacsTuple {
    return {
        ...tuple,
        patientBirthDate: moment(tuple.patientBirthDate, 'YYYY/MM/DD').format('YYYYMMDD'),
        studyDate: moment(tuple.studyDate).format('YYYY/MM/DD'),
    };
}

export interface KeyImage {
    SOPInstanceUID: string;
    RepositoryKey: string;
    IdExamination: string;
    Caption: string;
    ExcludedFromReport: boolean;
    IsDeletable: boolean;
}


export function keyImageFromMessage(
    msg:
        | ModelKeyImage
        | ModelKeyImageInstanceInfo
        | DeepPascalCase<ModelKeyImage>
        | DeepPascalCase<ModelKeyImageInstanceInfo>,
): KeyImage {
    if ('instanceUID' in msg) {
        return {
            SOPInstanceUID: msg.instanceUID,
            RepositoryKey: msg.repositoryKey,
            IdExamination: '',
            Caption: '',
            ExcludedFromReport: false,
            IsDeletable: msg.isDeletable,
        };
    }
    return {
        SOPInstanceUID: msg.InstanceUID ?? null,
        RepositoryKey: msg.RepositoryKey,
        IdExamination: '',
        Caption: '',
        ExcludedFromReport: false,
        IsDeletable: msg.IsDeletable ?? true,
    };
}

export enum XmlRequestType {
    DiaImagingRVStrain,
    DiaImagingLVStrain,
    DiaImagingLVWallMotion,
    Caas,
    TeraRecon,
}

export function isVnextPacsStudyData(v: PacsStudyDataNg1 | PacsStudyDataVnext[]): v is PacsStudyDataVnext[] {
    return v instanceof Array;
}

export function toNg1PacsStudyData(data: PacsStudyDataVnext): PacsStudyDataNg1 {
    const result = new PacsStudyDataNg1();
    result.accessionNumber = data.study.accessionNumber;
    result.dateTime = data.study.studyDate as any;
    result.modality = data.study.modality;
    result.patientBirthDate = data.patient.birthDate as any;
    result.patientID = data.patient.patientId;
    result.patientName = data.patient.fullName;
    result.patientSex = data.patient.sex;
    result.studyInstanceUID = data.study.studyInstanceUID;

    return result;
}

export function fromNg1PacsStudyData(data: PacsStudyDataNg1): PacsStudyDataVnext {
    return {
        patient: {
            birthDate: data.patientBirthDate ? moment(data.patientBirthDate).format('YYYYMMDD') : undefined,
            patientId: data.patientID,
            fullName: data.patientName,
            sex: data.patientSex,
        },
        study: {
            accessionNumber: data.accessionNumber,
            studyDate: data.dateTime ? moment(data.dateTime).format('YYYYMMDD') : undefined,
            modality: data.modality,
            studyInstanceUID: data.studyInstanceUID,
        },
    };
}

export function fromNg1OpenParams(params: DeepPartial<ImagingOpenParams>): DeepPartial<OpenImagesOptions> {
    const discardAction = params.discardPreviousImages ? 'Discard' : params.appendToPreviousImages ? 'Append' : undefined;
    const discardAsk = params.ask ?? false;

    return {
        discardOption: {
            action: discardAction,
            ask: discardAsk,
        },
    };
}
